import { render, staticRenderFns } from "./video-device.vue?vue&type=template&id=59c1449c&scoped=true"
import script from "./video-device.vue?vue&type=script&lang=js"
export * from "./video-device.vue?vue&type=script&lang=js"
import style0 from "./video-device.vue?vue&type=style&index=0&id=59c1449c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1449c",
  null
  
)

export default component.exports